import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import type { LocationsCounters } from '@recruitee/locations-types';

@Injectable({ providedIn: 'root' })
export class LocationsCountersHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetch(): Observable<{ counters: LocationsCounters }> {
    return this.httpApi.get(`/locations/counters`);
  }
}
